import { clsx } from "clsx";
import type { ReactNode } from "react";
import { Text } from "../typography";

export interface SelectionCardProps {
  icon: ReactNode;
  title: string;
  description?: string;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  "aria-label"?: string;
}

export function SelectionCard({
  icon,
  title,
  description,
  selected = false,
  disabled = false,
  onClick,
  className,
  "aria-label": ariaLabel,
}: SelectionCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      aria-label={ariaLabel ?? title}
      className={clsx(
        "flex w-full flex-col items-start justify-center gap-4 rounded-2xl border bg-bgWhite p-6 text-left transition-all",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-accentCyan",
        disabled && "cursor-not-allowed opacity-60",
        !disabled && !selected && "hover:border-accentCyan",
        selected
          ? "border-accentCyan shadow-[0px_2px_12px_0px_rgba(23,202,65,0.2)]"
          : "border-borderDefault shadow-[0px_2px_12px_0px_rgba(190,189,217,0.2)]",
        className,
      )}
    >
      <div className="flex items-center gap-1.5">
        <span className="inline-flex size-7 shrink-0 items-center justify-center text-textDark">
          {icon}
        </span>
        <Text variant="bodyLgBold" tone="dark">
          {title}
        </Text>
      </div>
      {description ? (
        <Text variant="body" tone="body">
          {description}
        </Text>
      ) : null}
    </button>
  );
}
